import React from "react";

const Pagination = ({
  currentPage,
  totalPages,
  totalRecord,
  handlePageChange,
  itemsPerPage,
}) => {
  const maxPagesToShow = 5;
  let startPage = Math.max(0, currentPage - Math.floor(maxPagesToShow / 2));
  let endPage = Math.min(totalPages - 1, startPage + maxPagesToShow - 1);

  // Adjust start page if we're near the end
  if (endPage - startPage + 1 < maxPagesToShow) {
    startPage = Math.max(0, endPage - maxPagesToShow + 1);
  }

  return (
    <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
      <div className="dataTables_info">
        Showing {currentPage * itemsPerPage + 1} to{" "}
        {Math.min((currentPage + 1) * itemsPerPage, totalRecord)} of{" "}
        {totalRecord} entries
      </div>
      <div className="d-flex align-items-center">
        <nav>
          <ul className="pagination pagination-gutter pagination-primary no-bg">
            {/* First Page */}
            <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => handlePageChange(0)}
                disabled={currentPage === 0}
              >
                <i className="fa fa-angle-double-left"></i>
              </button>
            </li>

            {/* Previous */}
            <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 0}
              >
                <i className="fa fa-angle-left"></i>
              </button>
            </li>

            {/* Show ellipsis if not at start */}
            {startPage > 0 && (
              <li className="page-item">
                <span className="page-link">...</span>
              </li>
            )}

            {/* Page Numbers */}
            {Array.from(
              { length: endPage - startPage + 1 },
              (_, i) => startPage + i
            ).map((pageNum) => (
              <li
                key={pageNum}
                className={`page-item ${
                  pageNum === currentPage ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(pageNum)}
                >
                  {pageNum + 1}
                </button>
              </li>
            ))}

            {/* Show ellipsis if not at end */}
            {endPage < totalPages - 1 && (
              <li className="page-item">
                <span className="page-link">...</span>
              </li>
            )}

            {/* Next */}
            <li
              className={`page-item ${
                currentPage === totalPages - 1 ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages - 1}
              >
                <i className="fa fa-angle-right"></i>
              </button>
            </li>

            {/* Last Page */}
            <li
              className={`page-item ${
                currentPage === totalPages - 1 ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(totalPages - 1)}
                disabled={currentPage === totalPages - 1}
              >
                <i className="fa fa-angle-double-right"></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Pagination;
